import React from 'react';
import Card from './Card';

const OSSContribution = ({ project, description, url, icon }) => (
    <Card url={url} icon={icon}>
        <div>
            <p><strong>Project: </strong>{project}</p>
            <p><strong>Description: </strong>{description}</p>
        </div>
    </Card>
);

export default OSSContribution;